// extracted by mini-css-extract-plugin
export default {"screen-loading":"IdentityVerification_screen-loading__I1M0e"};